import { STAYS_SITE_HOST } from '../siteConfig';
import { BrandConfig } from './types';

/**
 * The stays site (spec 016): Airbnb-style places to stay on the same build.
 *
 * Placeholder identity until the brand is decided (spec 016 D1 domain and
 * name, D8 visuals): a neutral teal and sand palette, the default icons and
 * the default policy folder. Replace these together with the backend brand
 * row (`brandSite` must match it) and `public/brands/stays/` when D8 lands.
 * The legal entity in `public/policies/stays/` changes with it.
 */
export const STAYS_BRAND: BrandConfig = {
  id: 'stays',
  brandSite: STAYS_SITE_HOST,
  name: 'Autopilotee Stays',
  siteTitle: 'Autopilotee Stays',
  legalName: 'Jidosoju Holding Inc.',
  supportEmail: 'support@autopilotee.com',
  supportPhone: '',
  // Written for places to stay (spec 016 W26): terms, the five cancellation policies the
  // booking system applies, privacy, account deletion and the host agreement.
  policyBasePath: '/policies/stays',
  assets: {
    favicon: '/favicon.ico',
    appleTouchIcon: '/logo192.png',
    manifest: '/manifest.json',
  },
  copy: {
    heroHeadline: 'Find a place to stay',
    heroSubcopy:
      'Homes, cabins and apartments from local hosts. See the full price up front and book in a few taps.',
    about:
      'Autopilotee Stays connects travelers with places to stay run by local hosts: whole homes for families, cabins for a weekend away and apartments for a month in a new city. Every listing shows the nightly price, cleaning fee and taxes before you book, along with the house rules and the cancellation policy the host chose. Hosts set their own calendars and choose whether guests book instantly or send a request first.',
    metaDescription:
      'Autopilotee Stays — homes, cabins and apartments from local hosts, with the full price shown before you book.',
    // Stays have no protection plans (spec 016 FR-016); the field is required by BrandCopy.
    protectionDescription: '',
  },
  theme: {
    primary: '#0F5257',
    primaryHover: '#0B3F43',
    primaryLight: '#1E6F75',
    onPrimary: '#FFFFFF',
    accent: '#E9B872',
    textPrimary: '#1D2A2B',
    textSecondary: '#5B6869',
    bg: '#FFFFFF',
    bgSecondary: '#F5F2EC',
    bgElevated: '#FFFFFF',
    border: '#E2DDD3',
    fontSans: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontDisplay: "'Outfit', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  showStagingPlaceholderName: false,
};
